import Icon from '../components/Icon.vue'

Icon.register({
  shower: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M389.7 135.6l-158.1 158.1c-9.4 9.4-24.6 9.4-33.9 0l-11.3-11.3c-9.4-9.4-9.4-24.6 0-33.9l0.1-0.1c-34-40.2-35.2-98.9-3.4-140.4-12-7.5-26.1-11.9-41.3-11.9-42.9 0-77.8 34.9-77.8 77.8v306.2h-64v-306.2c0-78.2 63.6-141.8 141.8-141.8 36.9 0 70.6 14.2 95.9 37.4 35.9-11.5 76.5-4.5 106.7 21l0.1-0.1c9.4-9.4 24.6-9.4 33.9 0l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9zM384 208c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM416 208c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16-16-7.2-16-16zM512 208c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM352 240c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM400 224c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM480 240c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM320 272c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM352 272c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16-16-7.2-16-16zM448 272c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM320 304c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16-16-7.2-16-16zM416 304c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM320 336c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM384 336c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM352 368c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM320 400c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shower.js
// module id = 1887
// module chunks = 0